var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserLogoJazz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#4E002F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.55322 51.9533C14.1594 45.3331 21.8236 41 30.4998 41C38.9253 41 46.3965 45.0863 51.0395 51.3853C45.6248 56.713 38.1962 60 29.9998 60C22.0988 60 14.9111 56.9456 9.55322 51.9533Z",
    fill: "#F557EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41 21.7996H38.6094C39.7275 20.8642 40.1534 19.3239 39.5518 17.9412L37.1292 18.8969C37.864 17.6057 37.6563 15.9637 36.5169 14.8707L34.8291 16.4822C34.8984 15.0893 34.0624 13.7422 32.6355 13.1779L31.6399 15.4655C31.2139 14.0421 29.8403 13 28.2164 13V15.3333C27.2314 14.3014 25.6447 13.915 24.2178 14.4793L25.1762 16.6957C23.8238 15.9942 22.1041 16.1924 20.9593 17.2803L22.7536 18.9935C21.2735 18.902 19.8253 19.7052 19.2289 21.0879L21.4652 21.9724C20.0329 22.4045 19 23.6855 19 25.2004H21.6089C20.4376 26.1256 19.9797 27.7066 20.592 29.1198L22.7909 28.2505C22.152 29.5163 22.3863 31.0821 23.4831 32.1293L25.3359 30.3602C25.1602 31.8293 26.0121 33.2883 27.5136 33.8831L28.4347 31.7582C28.9298 33.0646 30.2449 34 31.7836 34V31.5599C32.7473 32.7139 34.4298 33.1765 35.9313 32.5817L34.9782 30.3856C36.304 30.9956 37.9439 30.772 39.0407 29.7248L37.2996 28.0625C38.8117 28.1946 40.3078 27.3863 40.9201 25.9782L38.5402 25.0327C39.9671 24.5904 41 23.3094 41 21.7996Z",
    fill: "#F557EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLogoJazz);
export default __webpack_public_path__ + "static/media/user-logo-jazz.f705cdc3cb39948d781988a97404ad54.svg";
export { ForwardRef as ReactComponent };